import { Component } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { MenuConfigEntry } from 'app/core/base-api';
import { ContentHeaderComponent } from '../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { TitleFunctionbarComponent } from '../../shared/components/title-functionbar/title-functionbar.component';
import { NgbDropdown, NgbDropdownMenu, NgbDropdownToggle } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { LinkListComponent } from './link/list/link-list.component';
import { GrundstueckRubrikConfigComponent } from './rubrik/grundstueck/grundstueck-rubrik-config.component';
import { PfandrechtRubrikConfigComponent } from './rubrik/recht/pfandrecht-rubrik-config.component';
import { StandardrechtRubrikConfigComponent } from './rubrik/recht/standardrecht-rubrik-config.component';

@Component({
  selector: 'cap-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    TranslatePipe,
    RouterLink,
    LinkListComponent,
    GrundstueckRubrikConfigComponent,
    PfandrechtRubrikConfigComponent,
    StandardrechtRubrikConfigComponent
  ]
})
export class ConfigurationComponent {
  menuElements = MenuConfigEntry.ElementEnum;

  constructor(protected route: ActivatedRoute) {
    keysToTranslate<string>(['configuration.konfigurationDerAnsicht']);
  }
}
